/**
 * A constant denoting whether or not an Online Resource is available
 **/

export type ResourceTypeFilter = { isOnlineResource: boolean; label: string };

export const RESOURCE_TYPE_FILTER: {
  PHYSICAL: ResourceTypeFilter;
  ONLINE: ResourceTypeFilter;
} = {
  PHYSICAL: {
    isOnlineResource: false,
    label: 'Physical Resource',
  },
  ONLINE: {
    isOnlineResource: true,
    label: 'Online Resource',
  },
};
